import React from "react";
import PropTypes from "prop-types";

import { useAccessTypeStore } from "scenes/Hubly/components/Workspace/components/hooks";

import { TaskIcon } from "..";

export function TaskFormIcon({ title, icon, onClick, hasForm }) {
  const { hasAccess } = useAccessTypeStore();

  return (
    <TaskIcon
      iconName={icon}
      iconNameOutline={icon}
      title={title}
      onClick={onClick}
      visible={hasAccess() || hasForm}
      expanded={hasForm}
      hasValue={hasForm}
    />
  );
}

TaskFormIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  hasForm: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.string,
};

TaskFormIcon.defaultProps = {
  hasForm: false,
  title: "Form",
  icon: "clipboard list",
};

export default TaskFormIcon;
